module.exports = (RESTService, CitiesService) ->
  'ngInject'
  {
    service: (countryId, cityId) ->
      RESTService.service('areas', CitiesService.service(countryId).one(cityId))
  }
